export const formTranslations = {
    'Form.field.required': '{{label}} is required.'
};
